
$(document).on("click", ".question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').removeClass('active');
    jQuery('.question_product,.faq_question,.column_testimonial_heading_slider_new,.included_faq_question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});
$(document).on("click", ".custom_button", function (e) {
    var video = jQuery(this).parents('.video_wrapper_custom').find('video');
if (jQuery(this).hasClass("active")) {
   jQuery(this).parents('.video_wrapper_custom').removeClass('video-active');
    jQuery(this).removeClass('active');
video.trigger('pause');
} else {
video.trigger('play');
  jQuery(this).parents('.video_wrapper_custom').addClass('video-active');
    jQuery(this).addClass('active');
}
});






$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.landing_page_product').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", "a[href='#why']", function (e) {
  e.preventDefault();
  document.querySelector('#why').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='/#why']", function (e) {
 if( $('#why').length ){
  e.preventDefault();
  document.querySelector('#why').scrollIntoView({
    behavior: 'smooth'
  })
 }
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});
$(document).on("click", "a[href='/#reviews']", function (e) {
 if( $('#reviews').length ){
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
 }
});

jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
 jQuery('body').addClass('window-os'); 
}
});





function isScrolledIntoView(elem) {
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();

    var elemTop = $(elem).offset().top;
    var elemBottom = elemTop + $(elem).height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}

$(window).scroll(function () {
    $('.custom_counter .icons_with_text_flex').each(function () {
      var this_element =  $(this);
      if (this_element.hasClass("start_count")) {
} else {
        if (isScrolledIntoView(this) === true) {
            this_element.addClass('start_count');
$('.count_js').each(function () {
    $(this).prop('Counter', 0).animate({
            Counter: $(this).data('value')
        }, {
        duration: 1000,
        easing: 'swing',
        step: function (now) {                      
            $(this).text(Math.ceil(now));
        }
    });
});
        }
      }
    });

});



$(document).on("click", ".menu-drawer-container:not([open]) .header__icon--menu", function (e) {
$(this).parent().addClass('menu-opening');
$('body').addClass('overflow-hidden-tablet');
});

$(document).on("click", ".menu-drawer-container[open] .header__icon--menu", function (e) {
$(this).parent().removeClass('menu-opening');
$('body').removeClass('overflow-hidden-tablet');
});


$(document).on("click", ".trigger_reviews_js_show", function (e) {
$('.review_with_text_landing_page_item.active').last().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().next().next().show();
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
$('.review_with_text_landing_page_item.active').last().next().addClass('active');
});


$(document).on("click", "a[href='#see_more_reviews']", function (e) {
  e.preventDefault();
$('.trigger_reviews_js_show').trigger('click');

});



$(document).on("click", ".custom_prev_pagination", function (e) {
var tab = parseInt($(this).attr('data_tab'));
var loop_max = 6*tab;
var loop_min = loop_max - 5;
var next_tab = tab+1;
var prev_tab = tab-1;
var current_tab = tab;
$('.custom_pag_number').removeClass('active');
$('.custom_pag_number[data_tab="'+current_tab+'"]').addClass('active');
$('.custom_next_pagination').attr('data_tab',next_tab);
$('.custom_prev_pagination').attr('data_tab',prev_tab);
$('.left_product_item').hide();
for(var i = loop_min; i <= loop_max; i++) {
$('.left_product_item:nth-child('+i+')').show();
}
});


$(document).on("click", ".custom_next_pagination", function (e) {
var tab = parseInt($(this).attr('data_tab'));
var loop_max = 6*tab;
var loop_min = loop_max - 5;
var next_tab = tab+1;
var prev_tab = tab-1;
var current_tab = tab;
$('.custom_pag_number').removeClass('active');
$('.custom_pag_number[data_tab="'+current_tab+'"]').addClass('active');
$('.custom_next_pagination').attr('data_tab',next_tab);
$('.custom_prev_pagination').attr('data_tab',prev_tab);
$('.left_product_item').hide();
for(var i = loop_min; i <= loop_max; i++) {
$('.left_product_item:nth-child('+i+')').show();
}
});


$(document).on("click", ".custom_pag_number", function (e) {
var tab = parseInt($(this).attr('data_tab'));
var loop_max = 6*tab;
var loop_min = loop_max - 5;
var next_tab = tab+1;
var prev_tab = tab-1;
var current_tab = tab;
$('.custom_pag_number').removeClass('active');
$('.custom_pag_number[data_tab="'+current_tab+'"]').addClass('active');
$('.custom_next_pagination').attr('data_tab',next_tab);
$('.custom_prev_pagination').attr('data_tab',prev_tab);
$('.left_product_item').hide();
for(var i = loop_min; i <= loop_max; i++) {
$('.left_product_item:nth-child('+i+')').show();
}
});




$(document).on("change", "select#find_fragnance_dropdown", function (e) {

var value = $(this).val();
if (value == ""){
$('.find_product_result').hide();
} else {
var value_array = value.split('|split|');
var title =value_array[0];
var price =value_array[1];
var variant_id =value_array[2];
var price_raw =value_array[3];
var compare_price =value_array[4];
var compare_price_currency =value_array[6];
if(compare_price != ""){
} else {
var compare_price =price_raw;
var compare_price_currency =price;
}
var image =value_array[5];
$('.find_product_result_button').attr('variant_id',variant_id);
$('.find_product_result_button').attr('price',price_raw);
$('.find_product_result_button').attr('compare_price',compare_price);
$('.find_product_result_button').attr('image',image);
$('.find_product_result_button').attr('compare_price_currency',compare_price_currency);
$('.find_product_result_button').attr('price_currency',price);
$('.find_product_result_button').attr('title',title);
$('.find_product_result_title').text(title);
$('.find_product_result').show();
}
});




$(document).on("click", ".select_fragrance_button", function (e) {
  e.preventDefault();
  document.querySelector('.landing_product_flex').scrollIntoView({
    behavior: 'smooth'
  })
});




$(document).on("click", ".find_product_result_button, .popup_product_add", function (e) {
var this_element = $(this);
this_element.addClass('loading_hk');
setTimeout(function() {
this_element.removeClass('loading_hk');
$('.custom_product_popup').hide();
}, 500);
var variant_id = $(this).attr('variant_id');
var title = $(this).attr('title');
var quantity = parseInt($(this).attr('quantity'));
var price = parseInt($(this).attr('price'));
var compare_price = parseInt($(this).attr('compare_price'));
var image = $(this).attr('image');
var price_currency = $(this).attr('price_currency');
var compare_price_currency = $(this).attr('compare_price_currency');
var quantity_loop = quantity-1;
for(var i=0; i<=quantity_loop; i++)  {
var target_add = $('.selected_products_item:not(.active)').eq(0);
target_add.attr('variant_id',variant_id);
target_add.attr('price',price);
target_add.attr('compare_price',compare_price);
target_add.find('.single_product_image img').attr('src',image);
target_add.find('.selected_product_title').text(title);
target_add.find('.price_single').text(price_currency);
if (compare_price>price){
target_add.find('.compare_price_single').text(compare_price_currency).show();
} else {
target_add.find('.compare_price_single').hide();
}
target_add.find('.locked').hide();
target_add.find('.unlocked').show();
target_add.addClass('active');
update_price();
}  
update_upsell();
});




$(document).on("click", "span.remove_product", function (e) {
var target_add = $(this).parents('.selected_products_item');
target_add.attr('variant_id','');
target_add.attr('price','');
target_add.attr('compare_price','');
target_add.find('.single_product_image img').attr('src','');
target_add.find('.selected_product_title').text('');
target_add.find('.price_single').text('');
target_add.find('.compare_price_single').text('').hide();
target_add.find('.locked').show();
target_add.find('.unlocked').hide();
target_add.removeClass('active');
update_price();
update_upsell();

});






$(document).on("click", ".left_product_item", function (e) {
var data_tab=$(this).attr('data_tab');
$('.custom_product_popup[data_tab="'+data_tab+'"]').show();
$('.custom_product_popup[data_tab="'+data_tab+'"] .slick-slider').slick('refresh');
});


$(document).on("click", ".close_popup,.popup_bg", function (e) {
$('.custom_product_popup').hide();
});


$(document).on("click", ".custom_minus:not([disabled])", function (e) {
var parent_div = $(this).parents('.popup_main_flex_right');
  var input = parent_div.find("input.custom_quantity_input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value - 1);
  input.val(new_value).trigger('change');
  if (new_value==0){
  parent_div.find('.custom_minus').attr('disabled','disabled');
  } else {
  parent_div.find('.custom_minus').removeAttr('disabled');
  }
  $('.custom_plus').removeAttr('disabled');
});
  
$(document).on("click", ".custom_plus:not([disabled])", function (e) {
var current = $('.selected_products_item.active').length;
var max = 4-current;
var parent_div = $(this).parents('.popup_main_flex_right');
  var input = parent_div.find("input.custom_quantity_input");
  var current_value = parseInt(input.val());
  var new_value = parseInt(current_value + 1);
  input.val(new_value).trigger('change');
 parent_div.find('.custom_minus').removeAttr('disabled');
  if (new_value>=max){
  $('.custom_plus').attr('disabled','disabled');
  } else {
  $('.custom_plus').removeAttr('disabled');
  }
});

$(document).on("change", "input.custom_quantity_input", function (e) {
  var current_value = parseInt($(this).val());
var parent_div = $(this).parents('.popup_main_flex_right');
parent_div.find('.popup_product_add').attr('quantity',current_value);
});


$(document).on("click", ".selected_products_item .selected_products_item_top", function (e) {
  e.preventDefault();
  document.querySelector('.landing_product_flex').scrollIntoView({
    behavior: 'smooth'
  })
});



$(document).on("click", ".upsell_button.active", function (e) {
var this_element = $(this);
this_element.addClass('loading_hk');
setTimeout(function() {
this_element.removeClass('loading_hk').toggleClass('added');
update_price();
}, 500);
});


function update_upsell() { 
$('.upsell_button').removeClass('active');
 if( $('.upsell_button.active').length ){
} else {
$('.upsell_button').removeClass('added');
 }
$('.selected_products_item.active .selected_product_title').each(function(){
var title = $(this).text();
var target_no = title.split(' ');
target_no = target_no[1];
$('select#upsell_products_list option').each(function(){
var title_loop = $(this).text();
var loop_value = $(this).val();
if(title_loop.indexOf(target_no) != -1){
$('select#upsell_products_list').val(loop_value);
}
});
var selected_upsell = $('select#upsell_products_list').val();
selected_upsell = selected_upsell.split('|split|');
var variant_id_upsell = selected_upsell[0];
var image_upsell = selected_upsell[1];
var target_add_upsell = $('.upsell_button:not(.active)').eq(0);
target_add_upsell.attr('variant_id',variant_id_upsell);
target_add_upsell.parents('.upsell_item').find('.upsell_image_top img').attr('src',image_upsell);
target_add_upsell.addClass('active');
update_price();
});
  
}